import React from 'react';
import { Button } from '@fluentui/react-components';
import {ICartRef} from "../../Api/Models/Cart";
import { useNavigate } from 'react-router-dom';
import MarkdownView from "react-showdown";
import { useLocalization } from '../Helpers/useLocalization';
interface IOrderListTableProps {
    carts: ICartRef[];
    onDetailsSelected?: (cart: ICartRef) => void;
}

const CartListTable: React.FC<IOrderListTableProps> = (props) => {
    const isMobile = window.innerWidth < 700;
    const nav = useNavigate();
    const L = useLocalization();
    if (isMobile) return (
        <div>
            {props.carts.map((cart) => (
                <div key={cart.id} style={{borderTop: '1px solid #ddd', marginTop: '1em'}}>
                    <h3>{cart.name}</h3>
                    <h3>{cart.description}</h3>
                    <p>{L('localization_cart_col_expiration_date')}: { cart.expirationDate ? new Date(cart.expirationDate).toLocaleString() :  L('localization_cart_expiration_none')}</p>
                    <p>{L('localization_cart_col_prepared_by')}: {cart.preparedBy}</p>
                </div>
            ))}
        </div>
    )
    return (
        <div>
            <table className='orders-table'>
                <thead>
                    <tr>
                        <th>{L('localization_cart_col_cart_name')}</th>
                        <th style={{width: '100px'}}>{L('localization_cart_col_description')}</th>
                        <th style={{width: '150px'}}>{L('localization_cart_col_expiration_date')}</th>
                        <th style={{width: '150px'}}>{L('localization_cart_col_prepared_by')}</th>
                        <th style={{width: '100px'}} />
                    </tr>
                </thead>
                <tbody>
                    {props.carts.map((cart) => (
                        <tr key={cart.id}>
                            <td>{cart.name}</td>
                            <td style={{textAlign: 'center'}}><MarkdownView markdown={cart.description ?? ""}/></td>
                            <td style={{textAlign: 'center'}}>{cart.expirationDate ? new Date(cart.expirationDate).toLocaleString() : L('localization_cart_expiration_none')}</td>
                            <td style={{textAlign: 'center'}}>{cart.preparedBy}</td>
                            <td>
                                <Button onClick={() => nav(`/prepared-cart/${cart.id}`)}>{L('localization_cart_select_button')}</Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default CartListTable;